import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import Icon from '../../common/Icon';
import { modelOf } from '../../../prop-types';
import ConfigStore from '../../../store/ConfigStore';
import ProductEnquiryForm from '../ProductEnquiryForm';
import globalTranslations from '../../../i18n/globalTranslations';
import ProductEnquiryType from '../../../types/ProductEnquiryType';

export class ProductEnquiryModal extends Component {
  render() {
    const { configStore, enquiry } = this.props;

    return (
      <Modal
        className="ProductEnquiryModal"
        size="md"
        toggle={this.props.toggle}
        isOpen={this.props.isOpen}
      >
        <ModalHeader
          className="ProductEnquiryModal__header"
          toggle={this.props.toggle}
        >
          <FormattedMessage {...enquiry.title} />
        </ModalHeader>
        <ModalBody>
          <ProductEnquiryForm id={this.props.id} type={enquiry.type} />
          <div className="ProductEnquiryModal__customer-service-open-hours">
            <FormattedMessage
              id="customerService.isOpen"
              defaultMessage="Customer service is open Mon - Fri {timespan}"
              values={{
                timespan: configStore.customerService.open
              }}
            />
          </div>
          <div className="ProductEnquiryModal__customer-service-phone-number">
            <Icon name="phone" />{' '}
            <FormattedMessage
              {...globalTranslations.infoCallPhone}
              values={{
                phone: configStore.customerService.phone
              }}
            />
          </div>
          {configStore.customerService.callCost && (
            <div
              className="ProductEnquiryModal__customer-service-call-cost"
              dangerouslySetInnerHTML={{
                __html: configStore.customerService.callCost
              }}
            />
          )}
        </ModalBody>
      </Modal>
    );
  }
}

ProductEnquiryModal.propTypes = {
  id: PropTypes.string.isRequired,
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  configStore: modelOf(ConfigStore).isRequired,
  enquiry: PropTypes.shape({
    title: PropTypes.object,
    type: PropTypes.oneOf(Object.values(ProductEnquiryType))
  }).isRequired
};

ProductEnquiryModal.defaultProps = {
  enquiry: {
    title: globalTranslations.productEnquiryTitle,
    type: ProductEnquiryType.MESSAGE
  }
};

export default inject('configStore')(ProductEnquiryModal);



// WEBPACK FOOTER //
// ./src/components/product-enquiry/ProductEnquiryModal/index.jsx